export const userMockJson = {
  id: '1',
  first_name: 'neil',
  last_name: 'tyson',
  email: 'neilthechamptyson.solar.com'
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/models/user/user-mock.json.ts